
  import { defineComponent, ref, computed } from 'vue';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useI18n } from 'vue-i18n/index';
  import CustomDatePicker from '@/components/search/CustomDatePicker.vue';

  export default defineComponent({
    name: 'marketeers-accounts-widget',
    props: {
      widgetClasses: String,
    },
    components: {
      CustomDatePicker,
    },
    async setup() {
      const { t, te } = useI18n();
      const loading = ref(true);
      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };
      const totalMarketeersAccounts = ref(0);
      const totalMarketeersAccountsChangePercentage = ref(0);
      const customDateFrom = ref('');
      const customDateTo = ref('');
      const showDatePicker = ref(false);

      const store = useStore();
      await store.dispatch(Actions.GET_MARKETEERS_ACCOUNTS);
      const data = computed(() => store.getters.marketeersAccountsDashboard);

      totalMarketeersAccounts.value =
        data.value.data.accountsSummary.totalMarketeersAccounts;
      totalMarketeersAccountsChangePercentage.value =
        data.value.data.accountsSummary.totalMarketeersAccountsChangePercentage;
      loading.value = false;

      const selectedPeriod = ref('last-7-days');

      const showCustomDatePicker = () => {
        showDatePicker.value = true;
        selectedPeriod.value = 'custom';
      };

      const applyCustomDates = async () => {
        if (!customDateFrom.value || !customDateTo.value) {
          alert('Please select both dates');
          return;
        }
        showDatePicker.value = false;
        await selectPeriod('custom');
      };

      const selectPeriod = async (period: string) => {
        loading.value = true;

        selectedPeriod.value = period;
        const obj = {
          dateRange: period,
          showTrend: false,
          dateFrom: '',
          dateTo: '',
        };

        if (period === 'custom' && customDateFrom.value && customDateTo.value) {
          obj.dateFrom = customDateFrom.value;
          obj.dateTo = customDateTo.value;
        }

        await store.dispatch(Actions.GET_MARKETEERS_ACCOUNTS, obj);

        const payload = computed(
          () => store.getters.marketeersAccountsDashboard
        );
        totalMarketeersAccounts.value =
          payload.value.data.accountsSummary.totalMarketeersAccounts;
        totalMarketeersAccountsChangePercentage.value =
          data.value.data.accountsSummary.totalMarketeersAccountsChangePercentage;
        loading.value = false;
      };

      const textColor = computed(() => {
        if (totalMarketeersAccountsChangePercentage.value > 0) return '#28a745';
        if (totalMarketeersAccountsChangePercentage.value < 0) return '#dc3545';
        return '#6c757d';
      });

      const arrowSrc = computed(() => {
        if (totalMarketeersAccountsChangePercentage.value > 0)
          return '/media/icons/dash/up.png';
        if (totalMarketeersAccountsChangePercentage.value < 0)
          return '/media/icons/dash/down.png';
        return '';
      });

      return {
        textColor,
        arrowSrc,
        totalMarketeersAccounts,
        totalMarketeersAccountsChangePercentage,
        data,
        loading,
        selectedPeriod,
        selectPeriod,
        translate,
        customDateFrom,
        customDateTo,
        showDatePicker,
        showCustomDatePicker,
        applyCustomDates,
      };
    },
  });
